import { format, parseISO } from 'date-fns';
import { enUS, ja, zhTW, es, ptBR, ru } from 'date-fns/locale';
import type { Locale } from 'date-fns';

const localeMap: Record<string, Locale> = {
  en: enUS,
  ja: ja,
  tw: zhTW,
  es: es,
  pt: ptBR,
  ru: ru,
};

export const getDateFnsLocale = (localeCode: string): Locale =>
  localeMap[localeCode] || enUS;

export const formatLocalizedDate = (
  date: string | Date,
  locale = 'en',
): string => {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return format(dateObj, 'PP', { locale: getDateFnsLocale(locale) });
};
